/**
 * Created by vblanco on 13/06/2017.
 */

(function () {
    'use strict';

    angular.module('app')
        .factory('Catalogo', Catalogo);

    /* @ngInject */
    function Catalogo($resource) {
        return $resource('api/admin/catalogo/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/catalogo/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/catalogo/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/catalogo/findAll'
            }
        });
    }
})();
